import React from 'react';
import PropTypes from 'prop-types';
import { set } from 'lodash';
import { connect } from 'react-redux';
import { mergePageThemeDefaults } from 'services/theme/duck';
import { getDisplayName } from 'helpers/component';

export default function PageThemeEnhancer({ store: storeKey = 'store', themeDefaults } = {}) {
    return function PageThemeHOC(WrappedComponent) {
        class PageTheme extends React.Component {
            constructor(props, context) {
                super(props);
                this.store = context[storeKey];
            }

            componentDidMount() {
                const defaults = Object.keys(themeDefaults).reduce((prev, itemKey) => {
                    const item = themeDefaults[itemKey];

                    let value = item;
                    if (typeof item === 'function') {
                        value = item(this.store.getState());
                    }

                    return set(prev, itemKey, value);
                }, {});

                this.props.mergePageThemeDefaults(defaults);
            }

            render() {
                // Wraps the input component in a container, without mutating it. Good!
                return <WrappedComponent {...this.props} />;
            }
        }

        PageTheme.contextTypes = {
            [storeKey]: PropTypes.object
        };

        PageTheme.displayName = `PageTheme(${getDisplayName(WrappedComponent)})`;

        return connect(null, { mergePageThemeDefaults })(PageTheme);
    };
}



// WEBPACK FOOTER //
// ./src/hoc/PageTheme.js